module.exports = __webpack_public_path__ + "static/media/tournament-tickets-icon.cf7d0231.svg";